import { CdkMenuModule, CdkMenuTrigger } from "@angular/cdk/menu";
import { ConnectedPosition } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { Component, computed, input, model, viewChild } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import dayjs from "dayjs";
import { first } from "rxjs";
import { Icon } from "../../icon/icon.component";
import { BaseInput } from "../base-input";
import {
    CalendarOutput,
    InputCalendar,
} from "../date/calendar/calendar.component";
import { Input } from "../input.component";
import { InputTimePicker } from "../time/time-picker/time-picker.component";

@Component({
    selector: "app-input-date-time-picker",
    templateUrl: "./input-date-time-picker.component.html",
    standalone: true,
    imports: [
        CommonModule,
        Input,
        Icon,
        InputCalendar,
        CdkMenuModule,
        InputTimePicker,
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputDateTimePicker,
            multi: true,
        },
    ],
})
export class InputDateTimePicker extends BaseInput<string> {
    icon = input<string>();
    init = input<boolean>(false);
    date = model<Date | null>(this.init() ? new Date() : null);
    time = model<string>("00:00");
    menuTrigger = viewChild(CdkMenuTrigger);

    datetime = computed(() => {
        const dateString = dayjs(this.date()).format("YYYY-MM-DD");
        const timeString = this.time();

        return `${dateString} ${timeString}`;
    });

    disabledPast = input<boolean>(false);
    disabledFuture = input<boolean>(false);
    position = input<ConnectedPosition[]>([
        {
            originX: "start",
            originY: "bottom",
            overlayX: "start",
            overlayY: "bottom",
        },
    ]);

    constructor() {
        super();
        toObservable(this.datetime).subscribe((value) => {
            this.value.set(dayjs(value).format("YYYY-MM-DD HH:mm"));
        });

        this.value$.pipe(first()).subscribe((value) => {
            if (value) {
                const [date, time] = value.split(" ");
                this.date.set(dayjs(date).toDate());
                this.time.set(time);
            }
        });
    }

    handleOpenCalendar() {
        if (this.readonly() || this.disabled()) return;

        if (this.menuTrigger()) {
            this.menuTrigger()?.open();
        }
    }

    handleInput(value: string): void {
        if (this.disabled()) return;

        this.date.set(dayjs(value).toDate());
    }

    handleSelect(ev: CalendarOutput) {
        if (this.disabled()) return;

        if (ev.value) {
            if (
                this.disabledFuture() &&
                dayjs(ev.value).isAfter(dayjs(), "day")
            ) {
                return;
            }

            if (
                this.disabledPast() &&
                dayjs(ev.value).isBefore(dayjs(), "day")
            ) {
                return;
            }
            this.date.set(dayjs(ev.value).toDate());
        }
    }

    handleTimePick(time: string) {
        this.time.set(time);
    }
}
